var tag = { exports: {} };
export {
  tag as __module
};
//# sourceMappingURL=tag.js.map
